// action
import {
    GET_QUICK_SUPPORT_CATEGORY_DETAIL,
    GET_QUICK_SUPPORT_CATEGORY_DETAIL_FAIL,
    GET_QUICK_SUPPORT_CATEGORY_DETAIL_SUCCESS,
    GET_QUICK_SUPPORT_CATEGORY_DETAIL_RESET
} from '../action/getQuickSupportCategoryDetailAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_QUICK_SUPPORT_CATEGORY_DETAIL:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_QUICK_SUPPORT_CATEGORY_DETAIL_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_QUICK_SUPPORT_CATEGORY_DETAIL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_QUICK_SUPPORT_CATEGORY_DETAIL_RESET:
            return initialState
        default:
            return state
    }
}